import React, { useState, useEffect } from "react";
import "./Ourclients.css";
import { Box, Button } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { Link } from "react-router-dom";

// Import all client images
import ClientImage1 from "../../../Assets/Images/Clients/Group 1272628229.webp";
import ClientImage2 from "../../../Assets/Images/Clients/Group 1272628230.webp";
import ClientImage3 from "../../../Assets/Images/Clients/Group 1272628233.webp";
import ClientImage4 from "../../../Assets/Images/Clients/Group 1272628235.webp";
import ClientImage5 from "../../../Assets/Images/Clients/Group 1272628236.webp";
import ClientImage6 from "../../../Assets/Images/Clients/Group 1272628239.webp";
import ClientImage7 from "../../../Assets/Images/Clients/Group 1272628241.webp";
import ClientImage8 from "../../../Assets/Images/Clients/Group 1272628244.webp";
import ClientImage9 from "../../../Assets/Images/Clients/Group 1272628247.webp";
import ClientImage10 from "../../../Assets/Images/Clients/Group 1272628248.webp";
import ClientImage11 from "../../../Assets/Images/Clients/Group 1272628252.webp";
import ClientImage12 from "../../../Assets/Images/Clients/Group 1272628255.webp";
import ClientImage13 from "../../../Assets/Images/Clients/Group 1272628256.webp";
import ClientImage14 from "../../../Assets/Images/Clients/Group 1272628257.webp";
import ClientImage15 from "../../../Assets/Images/Clients/Group 1272628258.webp";
import ClientImage16 from "../../../Assets/Images/Clients/Group 1272628259.webp";
import ClientImage17 from "../../../Assets/Images/Clients/Group 1272628327.webp";
import ClientImage18 from "../../../Assets/Images/Clients/Group 1272628261.webp";
import ClientImage19 from "../../../Assets/Images/Clients/Group 1272628263.webp";
import ClientImage20 from "../../../Assets/Images/Clients/Group 1272628266.webp";
import ClientImage21 from "../../../Assets/Images/Clients/Group 1272628267.webp";
import ClientImage22 from "../../../Assets/Images/Clients/Group 1272628268.webp";
import ClientImage23 from "../../../Assets/Images/Clients/Group 1272628270.webp";
import ClientImage24 from "../../../Assets/Images/Clients/Group 1272628272.webp";
import ClientImage25 from "../../../Assets/Images/Clients/Group 1272628274.webp";
import ClientImage26 from "../../../Assets/Images/Clients/Group 1272628276.webp";
import ClientImage27 from "../../../Assets/Images/Clients/Group 1272628278.webp";
import ClientImage28 from "../../../Assets/Images/Clients/Group 1272628280.webp";
import ClientImage29 from "../../../Assets/Images/Clients/Group 1272628282.webp";
import ClientImage30 from "../../../Assets/Images/Clients/Group 1272628284.webp";

import ClientImage31 from "../../../Assets/Images/Clients/Group 1272628284.webp";
import ClientImage32 from "../../../Assets/Images/Clients/Group 1272628286.webp";
import ClientImage33 from "../../../Assets/Images/Clients/Group 1272628288.webp";
import ClientImage34 from "../../../Assets/Images/Clients/Group 1272628290.webp";
import ClientImage35 from "../../../Assets/Images/Clients/Group 1272628293.webp";
import ClientImage36 from "../../../Assets/Images/Clients/Group 1272628295.webp";
import ClientImage37 from "../../../Assets/Images/Clients/Group 1272628297.webp";
import ClientImage38 from "../../../Assets/Images/Clients/Group 1272628298.webp";
import ClientImage39 from "../../../Assets/Images/Clients/Group 1272628300.webp";
import ClientImage40 from "../../../Assets/Images/Clients/Group 1272628302.webp";
import ClientImage41 from "../../../Assets/Images/Clients/Group 1272628304.webp";
import ClientImage42 from "../../../Assets/Images/Clients/Group 1272628306.webp";
import ClientImage43 from "../../../Assets/Images/Clients/Group 1272628308.webp";
import ClientImage44 from "../../../Assets/Images/Clients/Group 1272628310.webp";
import ClientImage45 from "../../../Assets/Images/Clients/Group 1272628312.webp";
import ClientImage46 from "../../../Assets/Images/Clients/Group 1272628314.webp";
import ClientImage47 from "../../../Assets/Images/Clients/Group 1272628316.webp";
import ClientImage48 from "../../../Assets/Images/Clients/Group 1272628317.webp";
import ClientImage49 from "../../../Assets/Images/Clients/Group 1272628318.webp";
import ClientImage50 from "../../../Assets/Images/Clients/Group 1272628321.webp";

function Ourclients() {
  const [shuffledImages, setShuffledImages] = useState([]);
  // Define an array containing all client images
  const clientImages = [
    ClientImage1,
    ClientImage2,
    ClientImage3,
    ClientImage4,
    ClientImage5,
    ClientImage6,
    ClientImage7,
    ClientImage8,
    ClientImage9,
    ClientImage10,
    ClientImage11,
    ClientImage12,
    ClientImage13,
    ClientImage14,
    ClientImage15,
    ClientImage16,
    ClientImage17,
    ClientImage18,
    ClientImage19,
    ClientImage20,
    ClientImage21,
    // ClientImage22,
    ClientImage23,
    // ClientImage24,
    ClientImage25,
    ClientImage26,
    ClientImage27,
    ClientImage28,
    ClientImage29,
    ClientImage30,
    ClientImage31,
    ClientImage32,
    ClientImage33,
    ClientImage34,
    ClientImage35,
    ClientImage36,
    ClientImage37,
    ClientImage38,
    ClientImage39,
    ClientImage40,
    ClientImage41,
    ClientImage42,
    ClientImage43,
    ClientImage44,
    ClientImage45,
    ClientImage46,
    ClientImage47,
    ClientImage48,
    ClientImage49,
    ClientImage50,
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      // Shuffle the array of client images
      const shuffled = clientImages
        .sort(() => Math.random() - 0.5)
        .slice(0, 12);
      setShuffledImages(shuffled);
    }, 4000);

    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, [clientImages]);

  return (
    <div className="Ourclients-home">
      <div className="Ourclients-home-heading">
        <div className="Ourclients-heading-first">
          <h2>Our Clients</h2>
        </div>
        <div className="Ourclients-heading-btn">
          <Box>
            <Link to="/clients" style={{ textDecoration: "none" }}>
              <Button
                variant="outlined"
                sx={{
                  border: "2px solid white",
                  color: "white",
                  width: "210px",
                  height: "50px",
                  borderRadius: "50px",
                  "&:hover": {
                    backgroundColor: "#fff",
                    color: "#000",
                    border: "#fff", // Set the hover background color to transparent
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: 20, // Adjust the size of the icon here
                  },
                }}
              >
                View All Clients <ArrowOutwardIcon />
              </Button>
            </Link>
          </Box>
        </div>
      </div>
      <div className="Ourclients-home-list">
        {shuffledImages.map((image, index) => (
          <div className="clients" key={index}>
            <img src={image} alt={`Client ${index}`} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Ourclients;
